import { FC, memo } from 'react'
import { Stack, Image as ImageComponent, Badge } from '@chakra-ui/react'

import { ImagesFromUploadImage } from '../../../../../../../../types'
import { useUploadImage } from 'components/uploads/UploadImage/context/Provider'

type Props = {
  imageItem: ImagesFromUploadImage
  selectedImage: ImagesFromUploadImage | undefined
  setSelectedImage: (newImage: ImagesFromUploadImage) => void
}

const ImageItem: FC<Props> = ({ imageItem, selectedImage, setSelectedImage }) => {
  const { images, image, size } = useUploadImage()

  const isActive = selectedImage === imageItem
  const isMainImage = images.length > 0 && image.id === imageItem.id

  return (
    <Stack
      p={1}
      width={size}
      height={size}
      className="accessible"
      rounded="md"
      bg={isActive ? 'primary' : 'light'}
      borderWidth="2px"
      borderColor={isActive ? 'primary' : 'light'}
      tabIndex={0}
      onClick={() => setSelectedImage(imageItem)}
      _hover={{ bg: 'primary' }}
      _focus={{ bg: 'primary' }}
      mb={4}
      position={'relative'}
    >
      {isMainImage && (
        <Badge
          position="absolute"
          bottom={2}
          right={2}
          fontSize={'0.8rem'}
          width={'auto'}
          variant="solid"
          colorScheme="green"
        >
          Ativa
        </Badge>
      )}
      <ImageComponent
        rounded="md"
        filter={`grayscale(${isMainImage ? '0.90' : '0'})`}
        loading="lazy"
        src={imageItem.url}
        alt="Imagem dinâmica"
      />
    </Stack>
  )
}

export default memo(ImageItem)
